<template>
  <div>
    <h4 class="mb-1">
      Аномалии дат рождения
    </h4>
    <p class="text-muted">
      Исходные данные результата не удаляются.
    </p>
    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      {{ errorText }}
    </b-alert>
    <b-table
      :items="rows"
      :fields="fields"
      :busy="loading"
      striped
      responsive
      empty-text="Аномалий нет"
    />
  </div>
</template>

<script>
import {
  BAlert,
  BTable,
} from 'bootstrap-vue'
import identityApi from '@/services/identity-api.service'

export default {
  name: 'AnomaliesPage',
  components: {
    BAlert,
    BTable,
  },
  data() {
    return {
      loading: false,
      errorText: '',
      rows: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'ФИО' },
        { key: 'birthday', label: 'Исходная дата' },
        { key: 'birth_year', label: 'Год' },
      ],
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const { data } = await identityApi.getAnomalies({ maxResultCount: 50 })
        this.rows = data.rows || []
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Ошибка загрузки'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
